import { FC, useEffect, useRef } from "react"
import WasmCanvas from "@/wasm3d/WasmCanvas"
import { attachmentModule, initSettingView, wasmModule } from "@/gluelayer"

export const Attachment3D: FC<{ initCallBack?: () => void }> = ({ initCallBack }) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)

  useEffect(() => {
    const initCanvas = () => {
      const canvas = document.getElementById("canvas") as HTMLCanvasElement
      if (canvas && !canvasRef.current) {
        canvasRef.current = canvas
        initSettingView(canvas).then(() => {
          initCallBack && initCallBack()
        })
      }
    }

    initCanvas()

    const checkInterval = setInterval(() => {
      const canvas = document.getElementById("canvas") as HTMLCanvasElement
      if (canvas && !canvasRef.current) {
        canvasRef.current = canvas
        initSettingView(canvas).then(() => {
          initCallBack && initCallBack()
        })
        clearInterval(checkInterval)
      }
    }, 100)

    return () => {
      clearInterval(checkInterval)
    }
  }, [])

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        // background: "linear-gradient(to top, #000000 0%, #717272 100%)",
      }}
    >
      <WasmCanvas />
    </div>
  )
}
